import { AssetsFile, BaseLoaderUtil, Letters } from '../../types/asset/asset.types.ts';
import { Letter } from '../../types/asset/letter.types.ts';
import { PreloadableAsset, PreloadableAssetType } from '../../types/asset/preloading.types.ts';

import { getAudioLettersProviderUtil } from '../audio/audio-phoneme-provider.util.ts';

export class LettersUtil implements BaseLoaderUtil {
  private static _instance: LettersUtil;
  private letters: Letters | null = null;

  private constructor(private readonly audioLettersProviderUtil = getAudioLettersProviderUtil()) {
    // Private constructor to enforce singleton pattern
  }

  public static get instance(): LettersUtil {
    if (!LettersUtil._instance) {
      LettersUtil._instance = new LettersUtil();
    }
    return LettersUtil._instance;
  }

  public load(assets: AssetsFile): void {
    this.letters = assets.letters;
    console.log(`Loaded ${Object.keys(this.letters).length} letters`);
  }

  public getLetter(letter: string): Letter | undefined {
    if (!this.letters) {
      return undefined;
    }

    if (letter in this.letters) {
      return this.letters[letter];
    }

    return this.letters[letter.toLowerCase()];
  }

  public getSingleLetterAssets(letter: string): PreloadableAsset[] {
    return [
      {
        type: PreloadableAssetType.Audio,
        url: this.audioLettersProviderUtil.getLetter(letter),
      },
    ];
  }

  public getLetterAssets(): PreloadableAsset[] {
    if (!this.letters) {
      return [];
    }

    const assets = Object.keys(this.letters).map((letter) => this.getSingleLetterAssets(letter));
    return assets.flat();
  }
}

export const getLettersUtil = (): LettersUtil => LettersUtil.instance;
